var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page_content"},[_c('div',{staticClass:"boxi"},[(_vm.supports.length > 0)?_c('div',_vm._l((_vm.supports),function(item){return _c('div',[_c('support-section',{attrs:{"title":item.title,"items":item.items}})],1)}),0):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }